import { useMemo } from 'react';
import { useQueryString } from '@entegral/helpers.react/hooks/query-string';

export function useQueryFilters() {
  let { query, updateQuery } = useQueryString(true);

  let queryFilters = useMemo(() => {
      let defaults = {};

      if (query.status) defaults.status = query.status;
      if (query.areas) defaults.areas = query.areas;
      if (query.types) defaults.types = query.types.map(x => x.type ? { group: x.maintype, value: x.type } : { isGroup: true, name: x.maintype });
      if (query.priceFrom) defaults.priceMin = query.priceFrom;
      if (query.priceTo) defaults.priceMax = query.priceTo;
      if (query.beds) defaults.bedroom = parseInt(query.beds).toString();
      if (query.baths) defaults.bathroom = parseInt(query.baths).toString();
      if (query.garages) defaults.garage = parseInt(query.garages).toString();
      if (query.parking) defaults.parking = parseInt(query.parking).toString();
      if (query.building) defaults.buildingSize = query.building;
      if (query.buildingm) defaults.maxBuildingSize = query.buildingm;
      if (query.land) defaults.landSize = query.land;
      if (query.pool) defaults.pool = query.pool === `true`;
      if (query.pets) defaults.pets = query.pets === `true`;
      if (query.flatlet) defaults.flatlet = query.flatlet === `true`;
      if (query.staffRooms) defaults.staffRooms = query.staffRooms === `true`;
      if (query.dev) defaults.development = query.dev === `true`;
      if (query.onshow) defaults.onShow = query.onshow === `true`;
      if (query.reduced) defaults.reduced = query.reduced === `true`;
      if (query.furnished) defaults.furnished = query.furnished === `true`;
      if (query.features) defaults.features = query.features.split(',');

      return defaults;
    }, []);

  return {
    query: queryFilters,
    updateQuery,
  };
}
